<template>
	<div class="LoginBox">
		<div class="ModalWindow">
			<div class="CloseButton" @click="closeUpdate"></div>
		</div>

		<div id="Loginheader">
			<h2 class="loginHeaderh2">Unlock Content</h2>
			<span>Enter your information below and select Request Authorisation. You will receive an email once your request has been authorised. <br/> You can then request a code to access the Minimum Standards.</span>
			<span class="MessageDisplay">{{ this.messeage }}</span>
		</div>

		<div id="LoginContent">
			<form>
				<div class='row'>
					<div class='col'>
						<div class='form-group'>
							<label for="firstname">First Name</label> <span class="ErrorTxt" v-if="errors.firstname">{{ errors.firstname }}</span>
							<input type="firstname" v-model="userDetails.firstname" class="form-control" id="firstname" required autocomplete="off">
						</div>

						<div class='form-group'>
							<label for="email">Email</label> <span class="ErrorTxt" v-if="errors.userEmail">{{ errors.userEmail }}</span>
							<input type="email" v-model="userDetails.userEmail" class="form-control" id="email" required autocomplete="off">
						</div>

						<div class='form-group'>
							<label for="company">Company</label>
							<input type="company" v-model="userDetails.company" class="form-control" id="company" autocomplete="off">
						</div>

						<div class='form-group'>
							<label for="workAddress1">Work Address 1</label>
							<input type="workAddress1" v-model="userDetails.workAddress1" class="form-control" id="workAddress1" autocomplete="off">
						</div>

						<div class='form-group'>
							<label for="workAddress2">Work Address 2</label>
							<input type="workAddress2" v-model="userDetails.workAddress2" class="form-control" id="workAddress2" autocomplete="off">
						</div>

						<div class='form-group'>
							<label for="country">Country</label>
							<input type="country" v-model="userDetails.country" class="form-control" id="country" autocomplete="off"> 
						</div>
					</div>

					<div class='col'>
						<div class='form-group'>
							<label for="lastname">Last Name</label> <span class="ErrorTxt" v-if="errors.lastname">{{ errors.lastname }}</span>
							<input type="lastname" v-model="userDetails.lastname" class="form-control" id="lastname" required autocomplete="off">
						</div>

						<div class='form-group'>
							<label for="phoneNumber">Full Internatonal Phone Number</label>
							<input type="phoneNumber" v-model="userDetails.phoneNumber" class="form-control" id="phoneNumber" autocomplete="off">
						</div>

						<div class='form-group'>
							<label for="city">City</label>
							<input type="city" v-model="userDetails.city" class="form-control" id="city" autocomplete="off">
						</div>

						<div class='form-group'>
							<label for="siteCounty">Site / County</label>
							<input type="siteCounty" v-model="userDetails.siteCounty" class="form-control" id="siteCounty" autocomplete="off">
						</div>

						<div class='form-group'>
							<label for="zipPostalCode">ZIP / Postal Code</label>
							<input type="zipPostalCode" v-model="userDetails.zipPostalCode" class="form-control" id="zipPostalCode" autocomplete="off">
						</div>

						<div class='form-group'>
							<input type="button" @click="sendDetails" class="btn btn-primary RequestCodeButton" value="Request Access" autocomplete="off">
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	import axios from "axios";

	export default {
		data () {
			return {
				userDetails: {
					firstname: "",
					lastname: "",
					userEmail: "",
					phoneNumber: "",
					company: "",
					workAddress1: "",
					workAddress2: "",
					city: "",
					siteCounty: "",
					zipPostalCode: "",
					country: "",
				},
				messeage: "",
				accessDetails: {
					token: ""
				},
				errors: {
					firstname: "",
					lastname: "",
					userEmail: ""
				},
			}
		},

		methods: {

			closeUpdate () {
				this.$emit('loginState', false)
				this.$emit('close')
			},

			sendDetails() {
				// Check For Inputs, Mark Missing Required
				if (this.userDetails.firstname == "") {
					this.errors.firstname = "Firstname is required.";
				} else {
					this.errors.firstname = "";
				}

				if (this.userDetails.lastname == "") {
					this.errors.lastname = "Lastname is required.";
				} else {
					this.errors.lastname = "";
				}

				if (this.userDetails.userEmail == "") {
					this.errors.userEmail = "Email is required.";
				} else {
					this.errors.userEmail = "";
				}

				// Check Error Are Empty Below Sending Request
				if (this.isEmpty() ) {
					//Create a new formData Object to hold form data
					var formDataDetails = new FormData();

					// loop through the userdetails and if the value is not blank then append it to the formData var. 
					for (var key in this.userDetails) {

						if (this.userDetails[key]!=""){
							// append the key and value to the form data and then include in the post request
							formDataDetails.append(key, this.userDetails[key]);
						}
					}

					const GetURL = "https://www.rolls-royce.com/supplychain/admin/php/auth.php?getaccess=1";

					axios.post(GetURL, formDataDetails, {headers:{"Content-Type":'multipart/form-data'}}).then(res => {
						// Get Data From Server
						let GetDataType = res.data;

						// Check On Data Type, If "1" Add Success Message.
						if (GetDataType === 1) {
							this.messeage = "Success. Your details have been sent for approval."
						} else {
							this.messeage = "Sorry there was an error, please try again.";
						}

					}).catch(error => {
						console.log(error);
						this.messeage = "Sorry there was an error, please try again.";
					}); //End of Axios POST Request
				}
			},

			isEmpty() {
				// Get Length of each error
				let lgthEmail = this.errors.userEmail.length;
				let lgthFirst = this.errors.firstname.length;
				let lgthLast = this.errors.lastname.length;

				if (lgthEmail <= 0 && lgthFirst <= 0 && lgthLast <= 0) {
					return true;
				}

				return false;
			}
		},
	}
</script>


